export class ProgramSearchSelectionCriteria {
  programName: string;
  programType: string;
  programStatus: string;
}
